import { isWeChat, getCookie, setCookie, getUserAgent, getQueryString} from "@/assets/js/util";
import { createOrder, aliPayOrder, enTrustWeb, trustH5 } from '@/api'
import wechat from '@/api/wechat'
import {Dialog} from "vant";
export  default {
  template:``,
  data() {
    return {
      directWxUrl:['492010426041634816','492010496367529984','492010546946641920','492010598863736832','492778756448980992','492778818210107392','493044153349836800'],
      codeWxUrl:['485536260882960384','482335123136581632','476421517006082048','474942082448887808','474955174369038336','474955107981594624','474955032609951744','474954943942365184'],
      codeWxUrl1:['490628827928596480','490234814763372544'],
      flag:false,
      ossPath:"https://cdn.sxfoundation.com",
      companys: {
        'shanxing': {
          add: '西安市经开区经开万科中心436号',
          no: '陕ICP备19023826号-1',
          tel: 'shanxingcishan@163.com',
        },
        'smile': {
          no: '浙ICP备14020886号-1',
        },
        'zjfdp': {
          add: '杭州市西湖区留和路531号体训中心2号楼4楼',
          no: '浙ICP备14013029号',
          tel: '0571-89937125',
        },
        'scredcross': {
          add: '四川省成都市成华区玉双路3号8栋',
          no: '蜀ICP备18026319号-1',
          tel: '028-84332759',
        },
        'bee': {
          add: '四川省成都市成华区玉双路3号8栋',
          no: '蜀ICP备18026319号-1',
          tel: '028-84332759',
        },
      },
    }
  },
  components:{

  },
  methods: {
    doCopy(text){
      this.$copyText(text).then(function (e) {
        toast.text('复制成功')
      }, function (e) {
        toast.text('无法复制')
      })
    },
    dialogConfirm(str){
      let that = this
      Dialog.confirm({
        title: '提示',
        message: '请确认支付是否已完成',
        confirmButtonText: '已完成支付'
      })
        .then(() => {
          // on confirm
          localStorage.setItem('canConfirm', false)
          let SET_D = this.$route.query.SET_D
          if(SET_D){
            str += `?SET_D=${SET_D}`
          }
          that.$router.push(str)
        })
        .catch(() => {
          // on cancel
          localStorage.setItem('canConfirm', false)
        });
    },
    async payFn(params,method) {
      if (this.flag) return
      this.flag = true
      setTimeout(() => {
        this.flag = false
      }, 2000)
      let hasPost = sessionStorage.getItem('hasPost')
      if (hasPost) sessionStorage.removeItem('hasPost')
      let that = this
      let obj = params
      localStorage.setItem('donMoney', obj.donMoney)
      obj.isWeChat = isWeChat()
      obj.terminal = getUserAgent()
      let callback = localStorage.getItem('callback')
      let CFID = localStorage.getItem('CFID')
      let fid = obj.popularizeId
      if (callback && CFID == fid) {
        obj.callback = JSON.parse(callback).callback
        obj.callbackType = JSON.parse(callback).callbackType
      }
      if (method == 'MONTH'){
        _hmt.push(['_trackEvent', '用户操作', '点击弹窗月捐按钮']);
        let res;
        if (isWeChat()) {
          res = await enTrustWeb(obj)
        } else {
          res = await trustH5(obj)
        }
        setCookie('orderId', res.data.monthlyId)
        localStorage.setItem('canConfirm', true)
        localStorage.setItem('choose_month', true)
        location.href = res.data.redirectUrl
      }
      if(method == 'ALI'){
        if(localStorage.getItem('choose_month')) localStorage.removeItem('choose_month')
        _hmt.push(['_trackEvent', '用户操作', '点击弹窗支付宝按钮']);
        let res = await aliPayOrder(obj)
        if (res) {
          let reObj = res.data
          if (isWeChat()) {
            that.link = `https://${location.host}/payZfb/${reObj.id}`
            that.$refs.copyLink.show = true
          } else {
            that.$router.push(`/payZfb/${reObj.id}`)
          }
          return
        }
      }
      if(method == 'WX'){
        if(localStorage.getItem('choose_month')) localStorage.removeItem('choose_month')
        let res = await createOrder(obj)
        if (res && res.success) {
          let reObj = res.data
          setCookie('orderId', reObj.orderId)
          if (obj.isWeChat) {
            wechat.wxPay({
              timeStamp: res.data.timestamp,
              nonceStr: res.data.nonceStr,
              package1: res.data.prepayId,
              signType: res.data.signType,
              paySign: res.data.paySign,
            }, 'foundationPay', reObj.orderId, fid)
          } else {
            let SET_D = this.$route.query.SET_D
            this.dialogConfirm(`/success/${reObj.orderId}/${fid}`)
            localStorage.setItem("orderId", reObj.orderId)
            let url = `https://${location.host}/success/${reObj.orderId}/${fid}`
            if(SET_D){
              url += `?SET_D=${SET_D}`
            }
            location.replace(reObj.mwebUrl + "&redirect_url=" + encodeURIComponent(url))
          }
        }
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixin/index.js